import * as React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import get from 'lodash/get';
import PriceWidget from 'components/PriceWidget';
import SimpleImage from 'components/Common/Image/SimpleImage';
import ProductAvailabilityMessage from 'components/ProductAvailabilityMessage/ProductAvailabilityMessage';
import StringWidget from 'components/StringWidget';
import Checkbox from 'components/Checkbox/Checkbox';
import Button from 'components/Button/Button';
import Loader from 'components/Common/Loader/Loader';
import Error from 'components/Error/Error';
import { fetchProductSummaryAction } from 'actions/productSummaryActions';
import { browsedProducts } from 'utils/miscUtils';
import { isInit, isSuccess, isLoading, isError } from 'utils/asyncStatusHelper';
import getImageUrl from 'utils/getImageUrl';
import emptyCart from 'images/chat/empty-cart-illustration.jpg';
import emptyWishlist from 'images/chat/empty-wishlist-illustration.jpg';
import styles from './AttachProductModal.css';
export var AttachProductModalType;
(function (AttachProductModalType) {
    AttachProductModalType["CART"] = "CART";
    AttachProductModalType["WISHLIST"] = "WISHLIST";
    AttachProductModalType["RECENT"] = "RECENT";
})(AttachProductModalType || (AttachProductModalType = {}));
const { CART, WISHLIST, RECENT } = AttachProductModalType;
const ITEMS_PER_BATCH = 20;
class AttachProductModal extends React.Component {
    constructor(props) {
        super(props);
        this.getProductIds = () => {
            const { modalType, cartPids, wishlistPids } = this.props;
            switch (modalType) {
                case CART:
                    return cartPids;
                case WISHLIST:
                    return wishlistPids;
                case RECENT:
                    return this.recentPids;
                default:
                    return [];
            }
        };
        this.getProductFrom = () => {
            const { modalType } = this.props;
            switch (modalType) {
                case CART:
                    return 'Cart';
                case WISHLIST:
                    return 'Wishlist';
                case RECENT:
                    return 'Recently Viewed';
                default:
                    return '';
            }
        };
        this.fetchProducts = pIds => {
            const productSummaryRequestObj = pIds.map(item => ({ productId: item }));
            this.props.fetchProductSummary(productSummaryRequestObj);
        };
        this.fetchNextProducts = () => {
            const pIds = this.getProductIds();
            if (this.page * ITEMS_PER_BATCH < pIds.length) {
                const productToFetch = pIds.slice(this.page * ITEMS_PER_BATCH, this.page * ITEMS_PER_BATCH + ITEMS_PER_BATCH);
                this.page++;
                if (productToFetch && productToFetch.length > 0) {
                    this.fetchProducts(productToFetch);
                    this.currentPids = this.currentPids.concat(productToFetch);
                }
            }
        };
        this.handleProductSelectionChange = key => product => {
            let currentSelection = this.state.selectedProducts;
            if (product.checked) {
                if (currentSelection.indexOf(key) === -1)
                    currentSelection.push(key);
            }
            else {
                currentSelection = this.state.selectedProducts.filter(item => item !== key);
            }
            this.setState({ selectedProducts: currentSelection });
        };
        this.onSendProducts = () => {
            this.props.onSendProducts(this.getProducts(this.state.selectedProducts));
            this.hideProductsModal();
        };
        this.isProductSelected = product => {
            return this.state.selectedProducts.indexOf(product.id) > -1;
        };
        this.getProducts = pids => {
            const { productsData } = this.props;
            return pids
                .map(productId => productId && productsData[productId] && productsData[productId].value)
                .filter(product => !!product);
        };
        this.isLoading = products => {
            return products.some(p => isInit(p) || isLoading(p));
        };
        this.isError = products => {
            return products.some(p => isError(p));
        };
        this.isSuccess = products => {
            return products.some(p => isSuccess(p));
        };
        this.hideProductsModal = () => {
            this.setState({
                selectedProducts: []
            });
        };
        this.renderModalState = products => {
            if (this.isLoading(products)) {
                return <Loader className={styles['loader-state']}/>;
            }
            else if (this.isError(products)) {
                return <Error className={styles['error-state']}/>;
            }
            else if (this.state.hasMore && this.isSuccess(products)) {
                return (<div className={styles['load-more']} onClick={this.fetchNextProducts}>
					<StringWidget strKey="chatAttachProductLoadMore"/>
				</div>);
            }
            else if (products.length === 0) {
                if (this.props.modalType !== CART && this.props.modalType !== WISHLIST) {
                    return null;
                }
                return (<div className={styles['empty-product-list']}>
					<img className={styles['empty-product-list-image']} src={this.props.modalType === CART ? emptyCart : emptyWishlist}/>

					<StringWidget strKey="chatEmptyProductList" attributes={{ name: this.getProductFrom() }} className={styles['empty-product-list-text']}/>

					<StringWidget strKey="chatEmptyProductListSubtext" attributes={{ name: this.getProductFrom().toLowerCase() }} className={styles['empty-product-list-subtext']}/>
				</div>);
            }
        };
        this.renderProducts = products => {
            return products.map(product => {
                const { id, media, pricing, titles, buyability } = product;
                const label = (<div className={styles['product']}>
					<div className={styles['details']}>
						<div className={styles['main-title']}>{titles.title}</div>

						<div className={styles['pricing']}>
							<PriceWidget pricing={pricing}/>
						</div>
					</div>
					<div className={styles['product-image']}>
						<SimpleImage src={getImageUrl(get(media, ['images', 0, 'url']), '200')}/>
						<ProductAvailabilityMessage {...buyability} className={styles['product-buyability']}/>
					</div>
				</div>);
                return (<div key={id} className={styles['product-container']}>
					<Checkbox key={id} label={label} iconClass={styles['product-checkbox']} onChange={this.handleProductSelectionChange(id)} checked={this.isProductSelected(product)}/>
				</div>);
            });
        };
        this.state = {
            selectedProducts: [],
            hasMore: false
        };
        this.page = 0;
        this.currentPids = [];
        this.recentPids = browsedProducts.getBrowsedPids();
    }
    componentDidMount() {
        this.fetchNextProducts();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const pIds = this.getProductIds();
        const { productsData } = nextProps;
        const products = pIds.map(productId => productsData[productId]).filter(product => !!product);
        if (this.isSuccess(products)) {
            this.setState({
                hasMore: pIds.length > this.currentPids.length
            });
        }
    }
    render() {
        const { selectedProducts } = this.state;
        const productFrom = this.getProductFrom();
        const { productsData } = this.props;
        const products = this.currentPids.map(productId => productsData[productId]);
        return (<div className={cx(styles['add-product-modal'], { [styles['empty-product-list-modal']]: products.length === 0 })}>
				<div className={styles['title']}>
					<StringWidget strKey="chatAddProductTitle" attributes={{ from: productFrom }}/>
				</div>

				<div className={styles['products-container']}>
					{this.renderProducts(this.getProducts(this.currentPids))}
					{this.renderModalState(products)}
				</div>

				{products.length > 0 && (<Button primary type="submit" className={styles['btn-send']} onClick={this.onSendProducts} disabled={selectedProducts && selectedProducts.length === 0}>
						<StringWidget strKey="cartSendProduct"/>
					</Button>)}
			</div>);
    }
}
// TODO: Replace any with appropriate types once user state reducer and actions files are migrated to TS.
const mapStateToProps = state => {
    return {
        cartPids: (get(state.userState, ['cart', 'items']) || []).map(p => p.pid),
        wishlistPids: get(state.userState, ['wishlist', 'productIds']) || [],
        productsData: state.productSummary
    };
};
const mapDispatchToProps = {
    fetchProductSummary: fetchProductSummaryAction
};
export default connect(mapStateToProps, mapDispatchToProps)(AttachProductModal);
